(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Captcha", [], factory);
	else if(typeof exports === 'object')
		exports["Captcha"] = factory();
	else
		root["Captcha"] = factory();
})(this, function() {
return 